module.exports = __webpack_public_path__ + "img/home8.e6a1b13a.svg";